__turbopack_context__.v({
  "multi_livestream__schedule": "Schedule-module-scss-module__79glvW__multi_livestream__schedule",
  "multi_livestream__schedule__container": "Schedule-module-scss-module__79glvW__multi_livestream__schedule__container",
  "multi_livestream__schedule__wrapper": "Schedule-module-scss-module__79glvW__multi_livestream__schedule__wrapper",
});
